import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LogoutIcon from '@mui/icons-material/Logout';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { styled } from '@mui/system';
import { useTheme } from '../../../context/themeContext';
import { useAuth } from '@redtrack/auth-core';

const RedSpan = styled('span')({
  color: 'red',
});

function TopBar() {
  const { toggleTheme, themeMode } = useTheme();
  const { user, logout } = useAuth();
  const handleLogout = () => logout();

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <strong>
            <RedSpan>Red</RedSpan>
            Track
          </strong>
          AdminV2
        </Typography>
        <IconButton color="inherit" onClick={toggleTheme}>
          {themeMode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
        <Typography variant="body1" component="span" sx={{ m: 1 }}>
          {user?.email}
        </Typography>
        <IconButton
          color="inherit"
          onClick={handleLogout}
        >
          <LogoutIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
